module.exports = __webpack_public_path__ + "img/xtiumcolor_x_mark.aed42d65.svg";